import { render, staticRenderFns } from "./OnePersonIcon.vue?vue&type=template&id=1626ac20&"
import script from "./OnePersonIcon.vue?vue&type=script&lang=ts&"
export * from "./OnePersonIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports